import { IUseWithdrawForm } from "@funds/components/WithdrawForm/IWithdrawForm";
import queryString from "query-string";
import { TUpdateWalletData } from "@funds/interfaces/IFundsGeneral";
import { IWalletDetails } from "@market/interfaces/IWallet";
import { ETransactionType } from "@funds/enums/ETransactionType";
import Big from "big.js";
import countries from "@features/staticData/countries";

export const isSelectedWalletCrypto = (
  selectedWalletType: IUseWithdrawForm["values"]["selectedWalletType"]
) => selectedWalletType === "tether";
export const currencyFromUrl = (url: string): string =>
  queryString.parse(url).currency;

export const updateWalletAfterTransaction = (
  data: TUpdateWalletData,
  wallet: IWalletDetails
): IWalletDetails => {
  let currentBalance: number;
  let balance: number;

  switch (data.type) {
    case ETransactionType.purchase:
    case ETransactionType.tradeIn:
      currentBalance = Number(
        Big(wallet.current_balance).plus(data.amount).toString()
      );
      balance = Number(Big(wallet.balance).plus(data.amount).toString());
      return { ...wallet, balance, current_balance: currentBalance };
    case ETransactionType.withdraw:
      balance = Number(Big(wallet.balance).minus(data.amount).toString());
      return { ...wallet, balance };
    case ETransactionType.cancel:
      balance = Number(Big(wallet.balance).plus(data.amount).toString());
      return { ...wallet, balance };
    case ETransactionType.tradeOut:
      currentBalance = Number(
        Big(wallet.current_balance).minus(data.amount).toString()
      );
      balance = Number(Big(wallet.balance).minus(data.amount).toString());
      return { ...wallet, balance, current_balance: currentBalance };
    default:
      return { ...wallet };
  }
};

export const getCountryNamesArray = (countriesToFind: string[]) =>
  countriesToFind
    .map(
      (countryToFind) =>
        countries.find((country) => countryToFind === country.slug)?.name
    )
    .join(", ");

export const isTier1AndAbove = (tier: string) =>
  [null, undefined, "tier_0", "tier_0_kyc"].includes(tier);

export const isTier1UkRestricted = (tier: string) =>
  tier === "tier_1_uk_restricted";
